module.exports = __webpack_public_path__ + "e28aeb3e58b75ce54e6b2316aa38f267.pdf";